export const INITIAL_STATE = {
  isAuthenticated: false,
  accessToken: null,
  refreshToken: null,
  userWithOtp: null,
  verifiedOtp: null,
}
